var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('lottie-player',{ref:"player",staticStyle:{"width":"82px","height":"44px"},attrs:{"src":_vm.src,"background":"transparent","speed":"1","autoplay":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }